import useActiveWeb3React from '~/hooks/useActiveWeb3React'
import {Flex, LogoutIcon, Text, Toggle, useModal, UserMenu as UIKitUserMenu, UserMenuItem} from '@pancakeswap/uikit'
import ConnectWalletButton from '~/components/ConnectWalletButton'
import {FetchStatus, useGetBnbBalance} from '~/hooks/useTokenBalance'
import {CHAIN_ID, SUPPORTED_CHAINS} from '~/config/constants/chains'

import {useTranslation} from '~/contexts/Localization'
import SettingsModal from '../GlobalSettings/SettingsModal'


import WalletModal, {LOW_BNB_BALANCE, WalletView} from './WalletModal'
import WalletUserMenuItem from './WalletUserMenuItem'
import {Address, useAccount, useDisconnect, useNetwork} from "wagmi";
import {useAppMode} from "~/state/app/useAppMode";
import {AppMode} from "~/state/app/appModeSlice";
import {useMemo} from "react";

const UserMenu = () => {
  const {t} = useTranslation()
  const {account, chainId} = useActiveWeb3React()
  const {disconnect} = useDisconnect()
  const {balance, fetchStatus} = useGetBnbBalance()
  const {appMode, setAppMode} = useAppMode();

  const [onPresentWalletModal] = useModal(<WalletModal initialView={WalletView.WALLET_INFO}/>)
  const [onPresentSettingsModal] = useModal(<SettingsModal/>)

  const hasLowBnbBalance = fetchStatus === FetchStatus.SUCCESS && balance <= LOW_BNB_BALANCE

  const dexToggle = <Flex alignItems="center">
    <Text ml="40px" mr="5px"> {t('ShimmerSea')}</Text>
    <Toggle
      id="staked-only-farms"
      checked={appMode === AppMode.SWAPLINE}
      onChange={() => setAppMode(appMode === AppMode.SHIMMERSEA ? AppMode.SWAPLINE : AppMode.SHIMMERSEA)}
      scale="md"
      style={{marginTop: '2px'}}
    />
    <Text ml="5px"> {t('Swapline')}</Text>
  </Flex>

  const onDisconnect = () => {
    disconnect()
    window.location.reload()
  }

  const {chain: activeWalletChain} = useNetwork()
  const unsupported = useMemo(() => {
    return !SUPPORTED_CHAINS.includes(activeWalletChain?.id)
  }, [activeWalletChain?.id])

  if (account && unsupported) {
    return <><ConnectWalletButton wrongNetwork scale='sm'/>
      {dexToggle}
    </>
  }

  if (!account) {
    return <><ConnectWalletButton scale='sm'/>{dexToggle}</>
  }

  // @ts-ignore
  return (
    <Flex alignItems="center">
      <UIKitUserMenu account={account}>
        <WalletUserMenuItem hasLowBnbBalance={hasLowBnbBalance} onPresentWalletModal={onPresentWalletModal}/>
        <UserMenuItem as="button" onClick={() => onDisconnect()}>
          <Flex alignItems="center" justifyContent="space-between" width="100%">
            <Text> {t('Disconnect')}</Text>
            <LogoutIcon/>
          </Flex>
        </UserMenuItem>
      </UIKitUserMenu>
      {dexToggle}
    </Flex>
  )
}

export default UserMenu
